/********************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2021, 2024
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} **/
import React, { useContext } from 'react';

const ApiContext = React.createContext({});

const ApiHandlerProvider = ({ children, api, handler, loading, error }) => {
  return <ApiContext.Provider value={{ api, apiHandler: handler, loading, error }}>{children}</ApiContext.Provider>;
};

const useApi = () => useContext(ApiContext);

export default ApiHandlerProvider;
export { useApi, ApiContext };
